import axios from "axios";

export const getByArea = async (area) => {
  return axios
    .get(process.env.REACT_APP_SERVER_URL + "/BusStop/?area=" + area, {});
};